var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonBase } from '../ButtonBase';
import { LinkBase } from '../LinkBase';
export const InteractionBase = (_a) => {
    var { to, onClick, children } = _a, props = __rest(_a, ["to", "onClick", "children"]);
    if (to !== undefined) {
        return (_jsx(LinkBase, Object.assign({ to: to }, props, { children: children }), void 0));
    }
    return (_jsx(ButtonBase, Object.assign({ onClick: onClick }, props, { children: children }), void 0));
};
//# sourceMappingURL=InteractionBase.js.map